export default {
  state: {
  },
  getters: {
  },
  mutations: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/cfg.js